export class Menu {
  title: string;
  path: string;
  icon: string;
  subMenu: Menu[] | null;

  constructor(
    title: string,
    path: string,
    icon: string,
    subMenu: Menu[] | null
  ) {
    this.title = title;
    this.path = path;
    this.icon = icon;
    this.subMenu = subMenu;
  }
}
